import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Grade9Ready';
const SITE_URL = 'https://grade9ready.com';
const DEFAULT_IMAGE = 'https://customer-assets.emergentagent.com/job_pathway-to-9/artifacts/hhs9qhdc_Parent%20and%20child%20using%20grade9ready.png';
const DEFAULT_KEYWORDS = 'GCSE revision UK, GCSE Maths revision, GCSE English revision, GCSE Science revision, GCSE Geography revision, Year 10 revision, Year 11 revision, Grade 9 revision, parent GCSE revision platform';

export default function SEO({
  title,
  description,
  path = '/',
  type = 'website',
  image,
  noIndex = false,
  keywords = '',
  geo = 'United Kingdom',
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — GCSE Revision Platform for Grade 9`;
  const url = `${SITE_URL}${path}`;
  const img = image || DEFAULT_IMAGE;
  const mergedKeywords = [DEFAULT_KEYWORDS, keywords].filter(Boolean).join(', ');

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': ['EducationalOrganization', 'Organization'],
    name: SITE_NAME,
    url: SITE_URL,
    logo: img,
    description: description || 'UK GCSE revision platform for Year 10 and Year 11 students aiming for Grade 9 in Maths, English, Science and Geography.',
    areaServed: ['England', 'Scotland', 'Wales', 'Northern Ireland', 'United Kingdom'],
    audienceType: ['Year 10 students', 'Year 11 students', 'Parents and guardians'],
    addressCountry: 'GB',
    sameAs: ['https://grade9ready.com'],
  };

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={mergedKeywords} />
      <meta name="geo.region" content="GB" />
      <meta name="geo.placename" content={geo} />
      <meta name="geo.country" content="GB" />
      <meta name="language" content="en-GB" />
      <meta name="robots" content={noIndex ? 'noindex,nofollow' : 'index,follow,max-image-preview:large'} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="en_GB" />
      <meta property="og:country-name" content="United Kingdom" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />

      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
}
